import React from "react";
import SectionLabel from "./SectionLabel";

const EXPERIENCE = [
  {
    id: "ecode-networks",
    company: "Ecode Networks",
    role: "Software Engineering Intern — AI & Backend",
    location: "London, UK (Remote)",
    start: "2025.09",
    end: "2026.02",
    achievements: [
      {
        metric: "70%",
        body: "reduction in average query latency on the retrieval pipeline by re-architecting vector caching and batched embedding calls.",
      },
      {
        metric: "65%",
        body: "fewer hallucinations on internal QA workloads after introducing a structured re-ranking layer and grounded citation contracts.",
      },
      {
        metric: "57%",
        body: "lower infra spend month-over-month by migrating background jobs to an async worker pool with smarter back-pressure.",
      },
    ],
    stack: ["Langchain", "Typescript", "RAG", "Postgres", "Redis", "AZURE", "Cassandra", "Node.js","AstraDB", "OpenAI", "Langflow"],  
  },
];

export const Experience = () => {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="relative border-b border-line"
    >
      <div className="mx-auto max-w-6xl px-6 py-24">
        <SectionLabel
          index="01"
          label="EXPERIENCE"
          testId="experience-label"
        />

        <div className="mt-10 grid gap-10 md:grid-cols-12">
          {/* Left meta column */}
          <div className="md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-ink-dim">
              tail -f ./career.log
            </p>
            <p className="mt-3 font-sans text-sm text-ink-secondary">
              A short log. Quality over volume — one focused tour of duty,
              shipped real metrics.
            </p>
          </div>

          {/* Timeline column */}
          <div className="md:col-span-9">
            <ol className="relative space-y-10">
              {EXPERIENCE.map((entry) => (
                <li
                  key={entry.id}
                  data-testid={`experience-${entry.id}`}
                  className="card-terminal relative border border-line bg-bg-surface/60 p-6 md:p-8"
                >
                  {/* Header */}
                  <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-2">
                    <div className="flex items-baseline gap-3 font-mono text-[12px] uppercase tracking-[0.18em]">
                      <span className="text-accent">▸</span>
                      <span className="text-ink-primary">{entry.company}</span>
                      <span className="text-ink-dim">//</span>
                      <span className="text-ink-secondary">
                        {entry.location}
                      </span>
                    </div>
                    <div
                      data-testid={`experience-${entry.id}-timestamp`}
                      className="font-mono text-[12px] tracking-tight text-ink-secondary"
                    >
                      <span className="text-ink-dim">[</span>
                      <span className="text-accent">{entry.start}</span>
                      <span className="text-ink-dim"> — </span>
                      <span className="text-accent">{entry.end}</span>
                      <span className="text-ink-dim">]</span>
                    </div>
                  </div>

                  {/* Role */}
                  <h3 className="mt-3 font-mono text-xl text-ink-primary md:text-2xl">
                    {entry.role}
                  </h3>

                  {/* Achievements */}
                  <ul className="mt-6 space-y-4 font-sans text-base leading-relaxed text-ink-secondary">
                    {entry.achievements.map((a, i) => (
                      <li
                        key={i}
                        className="flex gap-4"
                        data-testid={`experience-${entry.id}-achievement-${i}`}
                      >
                        <span className="mt-[2px] font-mono text-xs text-ink-dim">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <p>
                          <span className="font-mono font-semibold text-accent">
                            {a.metric}
                          </span>{" "}
                          {a.body}
                        </p>
                      </li>
                    ))}
                  </ul>

                  {/* Stack chips */}
                  <div className="mt-7 flex flex-wrap gap-2">
                    {entry.stack.map((t) => (
                      <span
                        key={t}
                        className="border border-line px-2.5 py-1 font-mono text-[11px] uppercase tracking-widest text-ink-secondary"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
